import { isEmptyNullUndefined } from 'core-lib/utils/utils';

export function removeEmptyValues(data) {
  const obj = JSON.parse(JSON.stringify(data));
  if (typeof obj === 'string') {
    return obj;
  }
  if (Array.isArray(obj)) {
    obj.forEach((element, index) =>
      obj.splice(index, 1, removeEmptyValues(element))
    );
    return obj;
  }
  if (!isEmptyNullUndefined(obj)) {
    return Object.fromEntries(
      Object?.entries(obj)
        .filter(([, v]) => v !== null && v !== undefined)
        .map(([k, v]) => [k, v === Object(v) ? removeEmptyValues(v) : v])
    );
  }
  return {};
}
